import React, { useEffect, useState } from 'react';
import { getAuthStatus } from '../../localstorage';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
    const landingStyles = {
        backgroundColor: '#f9f9f9',
        padding: '20px',
        borderRadius: '5px',
    };

    const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate(); // Move useNavigate here

  useEffect(() => {
    const checkAuthentication = () => {
      const isAuthenticated = getAuthStatus('_id');
      if (!isAuthenticated) {
        navigate("/login");
      } else {
        setAuthenticated(true);
      }
    };

    checkAuthentication();
  }, [navigate]);


    return (
        <div>
            <h1>Responsive Landing Page</h1>
            <div style={landingStyles}>
                <h2>Welcome to Our Website!</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>
            <div>
                <h2>Code Snippet (HTML):</h2>
                <pre>{`
                <div class="landingStyles">
                    <h2>Welcome to Our Website!</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
                `}</pre>
            </div>
            <div>
                <h2>Code Snippet (CSS):</h2>
                <pre>{`
                 .landingStyles {
                    backgroundColor: #f9f9f9;
                    padding: 20px;
                    borderRadius: 5px;
                };
                `}</pre>
            </div>
        </div>
    );
}
